import { render, staticRenderFns } from "./TaskFormModal.vue?vue&type=template&id=75c2cd89&scoped=true"
import script from "./TaskFormModal.vue?vue&type=script&lang=js"
export * from "./TaskFormModal.vue?vue&type=script&lang=js"
import style0 from "./TaskFormModal.vue?vue&type=style&index=0&id=75c2cd89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c2cd89",
  null
  
)

export default component.exports